// Invite API functions for OnlyCoach

import { getApiClient } from './client';

export interface InviteToken {
  id: string;
  token: string;
  createdBy: string;
  cohortId: string | null;
  maxUses: number | null;
  usesCount: number;
  expiresAt: number | null;
  isActive: boolean;
  createdAt: number;
}

export interface CreateInviteRequest {
  cohortId?: string;
  maxUses?: number;
  expiresInDays?: number;
}

export interface ValidateInviteResponse {
  valid: boolean;
  cohortId?: string;
  error?: string;
}

// Create a new invite token
export async function createInvite(
  tenant: string,
  request: CreateInviteRequest = {}
): Promise<{ invite: InviteToken; inviteUrl: string }> {
  const client = getApiClient(tenant);
  return client.post<{ invite: InviteToken; inviteUrl: string }>('/invites', request);
}

// List my invite tokens
export async function listInvites(
  tenant: string
): Promise<{ invites: InviteToken[] }> {
  const client = getApiClient(tenant);
  return client.get<{ invites: InviteToken[] }>('/invites');
}

// Validate an invite token (public, no auth required)
export async function validateInvite(
  tenant: string,
  token: string
): Promise<ValidateInviteResponse> {
  const client = getApiClient(tenant);
  return client.get<ValidateInviteResponse>(`/invites/validate/${token}`);
}

// Deactivate an invite token
export async function deactivateInvite(
  tenant: string,
  inviteId: string
): Promise<{ success: boolean }> {
  const client = getApiClient(tenant);
  return client.delete<{ success: boolean }>(`/invites/${inviteId}`);
}

// Generate the invite URL for a token
export function getInviteUrl(tenant: string, token: string): string {
  const baseUrl = window.location.origin;
  return `${baseUrl}/${tenant}/join?invite=${token}`;
}
